import { render } from "./VersionManager.vue?vue&type=template&id=2d4f2814"
import script from "./VersionManager.vue?vue&type=script&lang=js"
export * from "./VersionManager.vue?vue&type=script&lang=js"

import "./VersionManager.vue?vue&type=style&index=0&id=2d4f2814&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__